/* AKS PRIVÉ — wishlist (localStorage). No app, no account.
   Store: localStorage "aks_wishlist" = [{id,title,url,image,price}] */
(function () {
  var KEY = 'aks_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('aks:wishlist:change', { detail: { list: list } }));
  }
  function has(id) { return read().some(function (i) { return i.id === id; }); }

  // Escape any value before it is interpolated into markup (localStorage is user-writable).
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function toggle(item) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.id === item.id; });
    if (idx > -1) { list.splice(idx, 1); } else { list.push(item); }
    write(list);
    return idx === -1; // true = now saved
  }

  function paintButton(btn) {
    var saved = has(btn.dataset.id);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.classList.toggle('is-saved', saved);
  }

  function paintAll() {
    document.querySelectorAll('[data-aks-wish]').forEach(paintButton);
    updateCount();
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-aks-wish-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.classList.toggle('is-empty', n === 0);
    });
  }

  // Delegated click for all save buttons (works for lazy-rendered cards).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aks-wish]');
    if (!btn) return;
    e.preventDefault();
    toggle({
      id: btn.dataset.id,
      title: btn.dataset.title,
      url: btn.dataset.url,
      image: btn.dataset.image,
      price: btn.dataset.price
    });
    paintButton(btn);
    updateCount();
  });

  document.addEventListener('aks:wishlist:change', paintAll);

  // Render the wishlist page grid if present.
  function renderPage() {
    var mount = document.getElementById('aks-wishlist-grid');
    if (!mount) return;
    var list = read();
    var empty = document.getElementById('aks-wishlist-empty');
    if (!list.length) {
      mount.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    mount.innerHTML = list.map(function (i) {
      var url = esc(i.url), img = esc(i.image), title = esc(i.title), price = esc(i.price), id = esc(i.id);
      return '<article class="aks-wl-card">' +
        '<a class="aks-wl-card__media" href="' + url + '">' +
          (i.image ? '<img src="' + img + '" alt="' + title + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="aks-wl-card__info">' +
          '<a class="aks-wl-card__title" href="' + url + '">' + title + '</a>' +
          '<span class="aks-wl-card__price">' + price + '</span>' +
          '<button type="button" class="aks-wl-card__remove" data-aks-wish data-id="' + id + '">Remove</button>' +
        '</div>' +
      '</article>';
    }).join('');
  }
  document.addEventListener('aks:wishlist:change', renderPage);

  if (document.readyState !== 'loading') { paintAll(); renderPage(); }
  else document.addEventListener('DOMContentLoaded', function () { paintAll(); renderPage(); });
})();
